export const APPOINTMENT_ALT = 'appointment'
export const OIL_CHANGE_ALT = 'oilChange'
export const VIEW_SPECIALS_ALT = 'specials'
export const SHOP_TIRES_ALT = 'shopTires'
export const SERVICES_ALT = 'services'

export const OIL_CHANGE_TITLE = 'Oil Change'
export const VIEW_SPECIALS_TITLE = 'View Specials'
export const SHOP_TIRES_TITLE = 'Shop Tires'
export const SERVICES_TITLE = 'All Services'

export const OIL_CHANGE_PRE_SELECTED_QUERY = 'oil-change'

export const INITIAL_HOVER_DATA_REGIONAL_DETAILS = {
  OIL_CHANGE_ALT: false,
  APPOINTMENT_ALT: false,
  VIEW_SPECIALS_ALT: false,
  SHOP_TIRES_ALT: false,
  SERVICES_ALT: false
}

export const APPOINTMENT_DESCRIPTION_REGIONAL_DETAILS = 'Oil change, tire services, brakes, batteries & more!'

// Class names for A/B testing purposes
export const REGIONAL_DEALS_BOOK_APPOINTMENT = 'regional-deals-book-appointment'
export const REGIONAL_DEALS_OIL_CHANGE = 'regional-deals-oil-change'
export const REGIONAL_DEALS_SPECIALS = 'regional-deals-specials'
export const REGIONAL_DEALS_SHOP_TIRES = 'regional-deals-shop-tires'
export const REGIONAL_DEALS_SERVICES = 'regional-deals-services'
